export default __webpack_public_path__ + "static/overview-81499c41142d323f1cdea3991d093534.gif";